var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C9.94126 1.25 7.6951 1.97907 5.95688 2.70396L5.89008 2.73181C4.98582 3.10873 4.39111 3.35662 3.76987 3.93283C3.27893 4.38818 2.77375 5.14621 2.54244 5.77459C2.24956 6.57025 2.24974 7.33709 2.25002 8.51252L2.25003 8.62361L2.25003 10.6972L2.25003 10.8133C2.2499 13.0097 2.24982 14.2749 2.68051 15.5967C3.0164 16.6276 3.78172 17.949 4.50875 18.7533C5.44074 19.7844 6.30472 20.28 7.79654 21.1358L7.85278 21.1681C8.59309 21.5928 9.34245 21.9807 10.0338 22.2645C10.7071 22.5409 11.3988 22.75 12 22.75C12.6012 22.75 13.2929 22.5409 13.9663 22.2645C14.6576 21.9807 15.407 21.5928 16.1473 21.1681L16.2035 21.1358L16.2036 21.1358C17.6954 20.28 18.5593 19.7844 19.4913 18.7533C20.2183 17.9489 20.9837 16.6276 21.3196 15.5967C21.7502 14.2749 21.7502 13.0097 21.75 10.8133L21.75 10.6972L21.75 8.62361L21.7501 8.51253C21.7503 7.33709 21.7505 6.57026 21.4576 5.77459C21.2263 5.14621 20.7211 4.38818 20.2302 3.93283C19.609 3.35662 19.0142 3.10873 18.11 2.73181L18.0432 2.70396C16.305 1.97907 14.0588 1.25 12 1.25Z",
    fill: "#0A213A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield1);
export default __webpack_public_path__ + "static/media/shield-1.a29a5865cad0900a2d9f635b70aecffa.svg";
export { ForwardRef as ReactComponent };